export const TooltipSelectors = {
	CursorTooltip: 'cursor-tooltip',
}
